export default __webpack_public_path__ + "static/源生云-9584ec5984699dda1a5c5fb4ec3d5e48.svg";